export type Color =
  | 'forest'
  | 'navy'
  | 'coolGrey'
  | 'violet'
  | 'rose'
  | 'red'
  | 'orange'
  | 'brown'
  | 'yellow'
  | 'green';

export type Variant = 5 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 95;

export type WhiteColors = 'white100' | 'white95';
type BlueGreyVariants = 10 | 20;
type BlueGreyColors = `blueGrey${BlueGreyVariants}`;
type LogoVariants = 'Dark' | 'Medium' | 'Light' | 'ProgressGradientStart' | 'ProgressGradientEnd';
type LogoColors = `logo${LogoVariants}`;
type ChartColorVariant = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
type ChartColorPrefix = 'chartStackedBar';
type ChartColors = `${ChartColorPrefix}${ChartColorVariant}`;
export type MainColor = `${Color}${Variant}` | WhiteColors | BlueGreyColors | LogoColors | ChartColors;

type MainColorsArray = MainColor[];

export type Colors = Record<MainColor, string>;

export type ColorsScheme = { [k: string]: MainColor | MainColorsArray | ColorsScheme };

export const colors: Colors = {
  forest5: '#F7FDFB',
  forest10: '#E2F9F1',
  forest20: '#D5F6EA',
  forest30: '#ABEDD6',
  forest40: '#4FC99E',
  forest50: '#229B70',
  forest60: '#1B7E5B',
  forest70: '#145C43',
  forest80: '#0E3F2E',
  forest90: '#092A1E',
  forest95: '#05150F',
  navy5: '#F6F8FE',
  navy10: '#E8EEFC',
  navy20: '#DBE4FA',
  navy30: '#BBCCF6',
  navy40: '#97B1F1',
  navy50: '#547EE9',
  navy60: '#3466E4',
  navy70: '#1947BD',
  navy80: '#113183',
  navy90: '#0B2056',
  navy95: '#06112D',
  white95: '#FBFBFB',
  white100: '#FFFFFF',
  coolGrey5: '#F6F7F8',
  coolGrey10: '#EEEFF2',
  coolGrey20: '#E5E7EB',
  coolGrey30: '#D1D4DC',
  coolGrey40: '#AEB4C1',
  coolGrey50: '#7D879B',
  coolGrey60: '#646D82',
  coolGrey70: '#4B5362',
  coolGrey80: '#333842',
  coolGrey90: '#21242B',
  coolGrey95: '#16181D',
  violet5: '#F7F5FF',
  violet10: '#F3F0FE',
  violet20: '#E7E2FE',
  violet30: '#D0C4FD',
  violet40: '#B8A7FB',
  violet50: '#896CF9',
  violet60: '#6D4AF7',
  violet70: '#4619F5',
  violet80: '#2B08B5',
  violet90: '#1D057A',
  violet95: '#110349',
  rose5: '#FDF7F8',
  rose10: '#FAEAEE',
  rose20: '#F8DEE4',
  rose30: '#F1C0CD',
  rose40: '#EA9FB2',
  rose50: '#DA5878',
  rose60: '#CD2D55',
  rose70: '#9B2240',
  rose80: '#6D182D',
  rose90: '#4B101F',
  rose95: '#2A0911',
  red5: '#FEF6F6',
  red10: '#FDE9E7',
  red20: '#FCDBD9',
  red30: '#FAC1BD',
  red40: '#F79892',
  red50: '#F04438',
  red60: '#D51D10',
  red70: '#A6170D',
  red80: '#720F09',
  red90: '#510B06',
  red95: '#2F0604',
  orange5: '#FEF9F5',
  orange10: '#FEF2EC',
  orange20: '#FCE5D9',
  orange30: '#FACBB3',
  orange40: '#F59E70',
  orange50: '#E95C11',
  orange60: '#BA490D',
  orange70: '#8F380A',
  orange80: '#642707',
  orange90: '#431A05',
  orange95: '#260F03',
  brown5: '#FAF8F5',
  brown10: '#F6F3EE',
  brown20: '#EEE7DD',
  brown30: '#DDCFBB',
  brown40: '#C2A985',
  brown50: '#A07F50',
  brown60: '#856942',
  brown70: '#634E31',
  brown80: '#443622',
  brown90: '#2C2316',
  brown95: '#18130C',
  yellow5: '#FFFCF5',
  yellow10: '#FEF3D8',
  yellow20: '#FCE8B5',
  yellow30: '#F9C84D',
  yellow40: '#DEA108',
  yellow50: '#AD7D06',
  yellow60: '#8A6405',
  yellow70: '#6C4F04',
  yellow80: '#4A3603',
  yellow90: '#312402',
  yellow95: '#1E1501',
  green5: '#F9FEF6',
  green10: '#EEFBE4',
  green20: '#DDF7C9',
  green30: '#B0D96C',
  green40: '#68C91C',
  green50: '#519C16',
  green60: '#407D12',
  green70: '#305E0D',
  green80: '#203F09',
  green90: '#172D06',
  green95: '#0C1603',
  blueGrey10: '#F2F6FD',
  blueGrey20: '#EBF1FC',
  logoDark: '#1D6F6B',
  logoMedium: '#23A060',
  logoLight: '#62BB94',
  logoProgressGradientStart: '#5CB778',
  logoProgressGradientEnd: '#1B7E5B',
  chartStackedBar0: '#3C4CC8',
  chartStackedBar1: '#1969DA',
  chartStackedBar2: '#0084E7',
  chartStackedBar3: '#0D9DF0',
  chartStackedBar4: '#40B5F6',
  chartStackedBar5: '#6ACBFA',
  chartStackedBar6: '#94E1FF',
  chartStackedBar7: '#7ED0E8',
  chartStackedBar8: '#69C0D1',
  chartStackedBar9: '#56AFBA',
  chartStackedBar10: '#449EA3',
  chartStackedBar11: '#358D8C',
  chartStackedBar12: '#277D76',
} as const;
